module.exports = __webpack_public_path__ + "25a479c714a27f13da208e6c4f9c4306.png";